import PortkeyStyleProvider from '../PortkeyStyleProvider';
import ReCaptchaModalCom from './index.component';

export default function ReCaptchaModal() {
  return (
    <PortkeyStyleProvider>
      <ReCaptchaModalCom />
    </PortkeyStyleProvider>
  );
}
